import Utils from "../../../../../../../shared/utils";

export const PLANE_ANIMATION = Utils.buildProductPageImageLink("rent/doublecheck/plane-animation-desk.svg");

export const PLANE_ANIMATION_MOBILE = Utils.buildProductPageImageLink("rent/doublecheck/plane-animation-mobile.svg");
